import {
    LOADING_STATE,
    UNREQUESTED_STATE,
} from '@perpay-web/data-module/constants';
import { createDataModuleReducer } from '@perpay-web/data-module/createDataModuleReducer';

// Only for use by internal data module api functions
const internalCreateDataModule = ({
    getRoot,
    initialValue,
    REQUEST_ACTION,
    ERROR_ACTION,
    SUCCESS_ACTION,
    RESET_ACTION,
    dataRequest,
    dataError,
    dataSuccess,
    dataReset,
    composedEpic,
    epic, // deprecated, present only for backward compatibility
}) => ({
    getRoot,
    initialValue,
    REQUEST_ACTION,
    ERROR_ACTION,
    SUCCESS_ACTION,
    RESET_ACTION,
    dataRequest,
    dataSuccess,
    dataError,
    dataReset,
    epic, // deprecated, present only for backward compatibility
    composedEpic,
    reducer: createDataModuleReducer(
        REQUEST_ACTION,
        ERROR_ACTION,
        SUCCESS_ACTION,
        RESET_ACTION,
        initialValue,
    ),
    getIsUnrequested: (state) =>
        getRoot(state).requestState === UNREQUESTED_STATE,
    getIsLoading: (state) => getRoot(state).requestState === LOADING_STATE,
    getIsLoadingOrUnrequested: (state) =>
        [UNREQUESTED_STATE, LOADING_STATE].includes(
            getRoot(state).requestState,
        ),
    getData: (state) => getRoot(state).value,
    getErrors: (state) => getRoot(state).errors,
});

/**
 * @typedef {Object} DataModuleParams
 * @property {Function} dataRequest
 * @property {Function} dataSuccess
 * @property {Function} dataError
 * @property {Function} dataReset
 * @property {Function} [epic]
 * @property {Function} [composedEpic]
 */

/**
 * @param {DataModuleParams} params
 * @returns {Function}
 * @deprecated The useDataModule hook should be used instead, with a context provider if needed as global state
 */
export const createDataModule = ({
    dataRequest,
    dataError,
    dataSuccess,
    dataReset,
    composedEpic,
    epic, // deprecated, present only for backward compatibility
}) => {
    const REQUEST_ACTION = dataRequest().type;
    const ERROR_ACTION = dataError().type;
    const SUCCESS_ACTION = dataSuccess().type;
    const RESET_ACTION = dataReset().type;

    const getDataModuleInstance = ({ getRoot, initialValue }) =>
        internalCreateDataModule({
            getRoot,
            initialValue,
            REQUEST_ACTION,
            ERROR_ACTION,
            SUCCESS_ACTION,
            RESET_ACTION,
            dataRequest,
            dataError,
            dataSuccess,
            dataReset,
            composedEpic,
            epic, // deprecated, present only for backward compatibility
        });
    return getDataModuleInstance;
};
